import { forwardRef } from "react"
import { IMaskInput } from "react-imask"

import dayjs from "dayjs"

export const TelephoneMask = forwardRef(function PhoneMask(props, ref) {
    const { onChange, ...other } = props

    return (
        <IMaskInput
            {...other}
            mask={[
                { mask: "(00) 0000-0000" },
                { mask: "(00) 00000-0000" }
            ]}
            inputRef={ref}
            overwrite={true}
            onAccept={(value) => onChange({ target: { value } })}
        />
    )
})

export const formatBRL = (value) => {
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
    }).format(value)
}

export const formatTelephone = (value) => {
    if (! value)
        return
    
    const digits = value.replace(/\D/g, '')

    const raw = digits.startsWith('55') ? digits.slice(2) : digits

    const areaCode = raw.slice(0, 2)
    const number = raw.slice(2)

    if (number.length === 9)
        return `(${areaCode}) ${number.slice(0, 5)}-${number.slice(5)}`
    else if (number.length === 8)
        return `(${areaCode}) ${number.slice(0, 4)}-${number.slice(4)}`
    else
        return value
}

export const isValidCPF = (cpf) => {
    cpf = cpf.replace(/\D/g, "")
    if (cpf.length !== 11)
        return false

    if (/^(\d)\1+$/.test(cpf))
        return false

    let sum = 0
    for (let i = 0; i < 9; i++)
        sum += parseInt(cpf[i]) * (10 - i)

    let firstDigit = (sum * 10) % 11
    if (firstDigit === 10) firstDigit = 0

    if (firstDigit !== parseInt(cpf[9]))
        return false

    sum = 0
    for (let i = 0; i < 10; i++)
        sum += parseInt(cpf[i]) * (11 - i)

    let secondDigit = (sum * 10) % 11
    if (secondDigit === 10) secondDigit = 0

    return secondDigit === parseInt(cpf[10])
}

export const isValidCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/\D/g, "")

    if (cnpj.length !== 14)
        return false

    if (/^(\d)\1+$/.test(cnpj))
        return false

    const calcCheckDigit = (base, weights) => {
        const sum = base
            .split("")
            .reduce((acc, num, i) => acc + num * weights[i], 0)

        const rest = sum % 11
        return rest < 2 ? 0 : 11 - rest
    }

    const base = cnpj.slice(0, 12)
    const digit1 = calcCheckDigit(base, [5,4,3,2,9,8,7,6,5,4,3,2])
    const digit2 = calcCheckDigit(base + digit1, [6,5,4,3,2,9,8,7,6,5,4,3,2])

    return cnpj === base + digit1.toString() + digit2.toString()
}

export const getBillingCycleProgress = (enterprise) => {
    if (!enterprise?.start_charging) {
        return 0
    }

    const startCharging = dayjs(enterprise.start_charging).startOf("day")
    const today = dayjs().startOf("day")

    if (!startCharging.isValid()) return 0

    const billingDay = startCharging.date()

    let cycleStart = today.date(billingDay).startOf("day")
    if (cycleStart.isAfter(today)) {
        cycleStart = cycleStart.subtract(1, "month")
    }

    let cycleEnd = cycleStart.add(1, "month")

    const totalMs = cycleEnd.diff(cycleStart, "millisecond")
    const elapsedMs = today.diff(cycleStart, "millisecond")

    let progress = (elapsedMs / totalMs) * 100

    progress = Math.max(0, Math.min(100, progress))

    return Math.round(progress)
}

export const getRenewalDate = (enterprise) => {
    if (!enterprise?.start_charging) {
        return enterprise?.end_charging ?? null
    }

    const startCharging = dayjs(enterprise.start_charging).startOf("day")

    if (!startCharging.isValid()) {
        return enterprise?.end_charging ?? null
    }

    const today = dayjs().startOf("day")
    const billingDay = startCharging.date()

    let nextRenewal = today.date(billingDay).startOf("day");
    if (nextRenewal.isBefore(today) || nextRenewal.isSame(today)) {
        nextRenewal = nextRenewal.add(1, "month")
    }

    return nextRenewal.toDate()
}

export const getGreetings = () => {
    const hour = new Date().getHours()
    if (hour >= 5 && hour < 12)
        return "bom dia"
    else if (hour >= 12 && hour < 18)
        return "boa tarde"
    else
        return "boa noite"
}
